import React, { Component } from 'react';
import FakeData from '../../fake-data';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";
import './EducationInit.css';
import { ItemPicker, Modal, ComboBox, TagView, PhonePicker, ConfirmModal } from '../../components/Common';
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import { AddSportFollow } from '../../App';
import { AddTeamWithSquads, AddedTeamItem } from './ClubInit';

export default class EducationInit extends Component {
    constructor(p) {
        super(p)
        this.state = {
            club: {
                name: "",
                sport: "",
                id: null,
                hash: null,
                email: "",
                phone: "",
                land: "",
                website: "",
                location: "",
                address: "",
                suburb: "",
                postal: "",
                state: "",
                country: "",
                teams: [],
                sports: [],
                socials: [],
                established: "",
                manager: { id: null, name: "" },
                secretary: { id: null, name: "" },
                about: "",
                otherPeople: [],
                sportPersons: [],
                settings: []
            },
            yourRole: {
                role: ""
            },
            confirmee: {
                name: "",
                email: ""
            },
            othersVerifications: [],
            roles: ["Head of sport department", "Assistant head of sport department", "Offer of sport department", "Director of sport department", "Assistant director of sport department", "Officer of a sport", "Head coach", "Assistant head coach", "Team captian", "Team player", "Student"],
            isAddingSports: false,
            isAddingTeams: false,
            isAddingPersons: false,
            canAddTeams: false,
            isAfterReg: false,
            phoneErr: false,
            landErr: false
        }
    }

    componentWillMount() {
        if (FakeData.getData("institutionalStore")) {
            const data = FakeData.getData("institutionalStore");
            this.state.club.name = data.name
            this.setState({
                club: this.state.club
            });
        }
    }

    save() {
        const club = this.state.club;
        const _teams = this.getTeamNames();
        if (club.name === "" || FakeData.inArray(this.state.club.name.toLowerCase(),_teams)) {
            this.setState({ nameErr: true });
            return;
        }

        if (this.state.yourRole.role === "") {
            this.setState({ roleErr: true });
            return;
        }

        if (club.email === "" || !FakeData.isEmail(club.email)) {
            this.setState({ emailErr: true });
            return;
        }

        if (club.phone === "" || this.state.phoneErr) {
            this.setState({ phoneErr: true });
            return;
        }

        if (club.land === "" || this.state.landErr) {
            this.setState({ landErr: true });
            return;
        }

        if (club.website === "" || !FakeData.isWebsite(club.website)) {
            this.setState({ webErr: true });
            return;
        }

        if (club.address === "") {
            this.setState({ addressErr: true });
            return;
        }

        if (club.suburb === "") {
            this.setState({ suburbErr: true });
            return;
        }

        if (club.location === "") {
            this.setState({ locationErr: true });
            return;
        }

        if (club.postal === "") {
            this.setState({ postalErr: true });
            return;
        }

        if (club.country === "") {
            this.setState({ countryErr: true });
            return;
        }

        if (club.state === "") {
            this.setState({ stateErr: true });
            return;
        }

        if (club.sports.length === 0) {
            this.setState({ sportsErr: true });
            return;
        }

        let sportPersonsErr = false;
        /*club.sportPersons.forEach((item, i) => {
            if (item.headDept.id === null) {
                item.headDeptErr = true;
                sportPersonsErr = true;
            }

            if (item.assDept.id === null) {
                item.assDeptErr = true;
                sportPersonsErr = true;
            }

            if (item.headCoach.id === null) {
                item.headCoachErr = true;
                sportPersonsErr = true;
            }

            if (item.assCoach.id === null) {
                item.assCoachErr = true;
                sportPersonsErr = true;
            }
        })

        this.setState({ sportPersonsErr: sportPersonsErr });

        if (sportPersonsErr) {
            return;
        }*/

        if (club.teams.length === 0 && this.state.canAddTeams) {
            this.setState({ teamsErr: true });
            return;
        }

        if (this.state.confirmee.name === "") {
            this.setState({ confirmeeNameErr: true });
            return;
        }

        if (this.state.confirmee.email === "" || !FakeData.isEmail(this.state.confirmee.email)) {
            this.setState({ confirmeeEmailErr: true });
            return;
        }

        const others = this.state.othersVerifications

        /*if ((this.state.yourRole.role === "Admin" || this.state.yourRole.role === "Staff") && (this.state.othersVerifications.length === 0)) {
            //console.log(this.state.yourRole.role, this.state.othersVerifications.length)
            this.setState({ needRoles: false });
        } else {
            this.setState({ needRoles: true });
            return;
        }*/

        let bool = false;
        for (let x = 0; x < others.length; x++) {
            let item = others[x];
            if (item.name === "") {
                item.nameError = true;
                this.setState({ othersVerifications: others });
                bool = true;
            }

            if (item.email === "" || !FakeData.isEmail(item.email)) {
                item.emailErr = true;
                this.setState({ othersVerifications: others });
                bool = true;
            }
        }

        if (bool) {
            return;
        }

        const _that = this;
        club['username'] = club.name.replace(" ","_").toLowerCase();
        this.setState({ club: club });
        const dataTo = {
            club: club,
            confirmee: this.state.confirmee,
            role: this.state.yourRole,
            otherPeople: others,
            user: FakeData.getData("yoo")
        }

        //console.log(dataTo)
        FakeData.post("/createInstitution.php?auth0", dataTo, {
            success: ((res) => {
                //console.log(res)
                if (res.error) {
                    FakeData.alert("An institution with the email or name provided already exists!");
                    _that.setState({ emailErr: true });
                } else {
                    _that.state.club.id = res.id;
                    _that.state.club.hash = res.hash;
                    _that.setState({ isAfterReg: true, club: _that.state.club });
                }
            }),
            error: ((err) => {

            })
        }, true, "Institution was created!", ((e) => { }))

    }

    getTeamNames = () => {
        const _teams = FakeData.getData("all_teams");
        const names = [];
        const rawNames = _teams.map((item, i)=>{
            return FakeData.nullify(item.rawName).toLowerCase();
        });

        const teamName = _teams.map((item, i)=>{
            return FakeData.nullify(item.name).split("(")[0].toLowerCase();
        });

        return names.concat(teamName, rawNames);
    }

    onSportsFollowAdd(arr) {
        if (arr.length === 0 && this.state.club.sports.length === 0) {
            this.setState({
                sportsErr: true,
                isAddingSports: false
            });
            return;
        }

        const currentSports = this.state.club.sports;
        const newSports = [];
        arr = FakeData.listify(arr);
        for (let i = 0; i < arr.length; i++) {
            const sport = arr[i];
            if (currentSports.indexOf(sport) > -1) {
                continue;
            } else {
                newSports.push(sport)
            }
        }

        for (let i = 0; i < currentSports.length; i++) {
            const sport = currentSports[i];
            if (arr.indexOf(sport) > -1) {
                continue;
            } else {
                currentSports.splice(i, 1)
            }
        }

        newSports.forEach((item, i) => {
            currentSports.push(item)
            this.state.club.sports = currentSports;
            this.setState({
                club: this.state.club,
                sportsErr: false,
                isAddingSports: false
            });
        })


        this.state.club.sportPersons = this.getSports();
        this.setState({
            club: this.state.club,
            sportsPersonErr: false
        });
    }

    onPhoneChange(num, err) {
        this.state.club.phone = num
        this.setState({ club: this.state.club, phoneErr: err });
    }

    onLandlineChange(num, err) {
        this.state.club.land = num
        this.setState({ club: this.state.club, landErr: err });
    }

    savePersons(arr) {
        this.state.club.sportPersons = arr;
        this.setState({ club: this.state.club, isAddingPersons: false, sportPersonsErr: false });
    }

    getSports() {
        const list = this.state.club.sports
        const currentSports = this.state.club.sportPersons;
        const newSports = [];

        for (let i = 0; i < list.length; i++) {
            const sport = list[i];
            let bool = false;
            for (let x = 0; x < currentSports.length; x++) {
                if (sport.id == currentSports[x].sportId) {
                    bool = true;
                    continue;
                }
            }

            if (!bool) {
                newSports.push(sport)
            }
        }

        for (let i = 0; i < currentSports.length; i++) {
            const sport = currentSports[i];
            let bool = false;
            for (let x = 0; x < list.length; x++) {
                if (sport.sportId == list[x].id) {
                    bool = true;
                }
            }

            if (!bool) {
                currentSports.splice(i, 1);
            }
        }

        newSports.forEach((item, i) => {
            const data = {
                name: item.name,
                sportId: item.id,
                image: item.image,
                headDept: { id: null, name: "" },
                assDept: { id: null, name: "" },
                headCoach: { id: null, name: "" },
                assCoach: { id: null, name: "" },
                headCoachErr: false,
                headDeptErr: false,
                assCoachErr: false,
                assDeptErr: false
            }

            currentSports.push(data)
        })

        return currentSports;
    }

    getSportsWithoutTeams() {
        const teams = this.state.club.teams;
        const sports = this.state.club.sports;
        const list = [];
        if (teams.length === 0) {
            return sports;
        }

        for (let i = 0; i < sports.length; i++) {
            const sport = sports[i];
            let found = false;
            for (let x = 0; x < teams.length; x++) {
                const team = teams[x];
                if (team.sport === sport.name) {
                    found = true;
                    break;
                }
            }

            if (!found) {
                list.push(sport)
            }
        }

        return list;
    }

    getSportByName(n){
        const sports = this.state.club.sports;
        const list = [];
        for (let i = 0; i < sports.length; i++) {
            const sport = sports[i];
            if(sport.name===n){
                list.push(sport);
                break;
            }
        }

        return list;
    }

    render() {
        const sports = this.getSportsWithoutTeams();
        const _teams = this.getTeamNames();
        return (
            <div className="full-screen-page">
                {!this.state.isAfterReg &&
                    <div className="after-register-profile" style={{ width: "85%" }}>
                        <div className="after-register-profile-content">
                            <div className="after-register-profile-content-head">
                                <img src="images/add_blu.svg" />
                                <h1>Institution Profile</h1>
                            </div>
                            <div className="after-register-profile-content-body">
                                <div className="register-profile-content-body-item">
                                    <h2>Institution Details</h2>
                                    <div>
                                        <input placeholder="Institution Name" className={(this.state.nameErr) ? "error" : FakeData.inArray(this.state.club.name.toLowerCase(),_teams)?"error": ""} value={this.state.club.name} onChange={(e) => {
                                            const val = e.target.value
                                            this.state.club.name = val;
                                            this.setState({ club: this.state.club, nameErr:  FakeData.inArray(val.toLowerCase(),_teams)?true:false });
                                        }} />
                                        <select className={(this.state.roleErr) ? "error" : ""} onChange={(e) => {
                                            const val = e.target.value
                                            this.state.yourRole.role = val;
                                            this.setState({ yourRole: this.state.yourRole, roleErr: false });
                                        }} value={this.state.yourRole.role}>
                                            <option value="" disabled={true} style={{ padding: "10px" }}>What is your role in the institution?</option>
                                            {
                                                this.state.roles.map((item, i) => {
                                                    return (
                                                        <option value={item} key={i} style={{ padding: "10px" }}>{item}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                        <div className="register-input">
                                            <img src="images/email_icon_blu.svg" />
                                            <input className={(this.state.emailErr) ? "error" : ""} placeholder="institutionname@clubwebsite.com" value={this.state.club.email} onChange={(e) => {
                                                const val = e.target.value
                                                this.state.club.email = val;
                                                this.setState({ club: this.state.club, emailErr: !FakeData.isEmail(val) });
                                            }} />
                                        </div>
                                        <div className="register-input">
                                            <img src="images/mobile_icon_blu.svg" />
                                            <PhonePicker className={(this.state.phoneErr) ? "error" : ""} value={this.state.club.phone} onChange={this.onPhoneChange.bind(this)} />
                                        </div>
                                        <div className="register-input">
                                            <img src="images/landline_icon_blu.svg" />
                                            <PhonePicker className={(this.state.landErr) ? "error" : ""} value={this.state.club.land} onChange={this.onLandlineChange.bind(this)} />
                                        </div>
                                        <div className="register-input">
                                            <img src="images/website_icon_blu.svg" />
                                            <input className={(this.state.webErr) ? "error" : ""} placeholder="www.institutionwebsite.com" value={this.state.club.website} onChange={(e) => {
                                                const val = e.target.value
                                                this.state.club.website = val;
                                                this.setState({ club: this.state.club, webErr: !FakeData.isWebsite(val) });
                                            }} />
                                        </div>
                                        <div className="register-input">
                                            <img src="images/location_icon.svg" />
                                            <input className={(this.state.addressErr) ? "error" : ""} placeholder="Address" value={this.state.club.address} onChange={(e) => {
                                                const val = e.target.value
                                                this.state.club.address = val;
                                                this.setState({ club: this.state.club, addressErr: false });
                                            }} />
                                        </div>
                                        <div className="register-input">
                                            <img src="" />
                                            <input className={(this.state.suburbErr) ? "error" : ""} placeholder="Suburb" value={this.state.club.suburb} onChange={(e) => {
                                                const val = e.target.value
                                                this.state.club.suburb = val;
                                                this.setState({ club: this.state.club, suburbErr: false });
                                            }} />
                                        </div>
                                        <div className="register-input">
                                            <img src="" />
                                            <input className={(this.state.locationErr) ? "error" : ""} placeholder="City" value={this.state.club.location} onChange={(e) => {
                                                const val = e.target.value
                                                this.state.club.location = val;
                                                this.setState({ club: this.state.club, locationErr: false });
                                            }} />
                                        </div>
                                        <div className="register-input">
                                            <img src="" />
                                            <input type="number" max="99999" className={(this.state.postalErr) ? "error" : ""} placeholder="Postal Code" value={this.state.club.postal} onChange={(e) => {
                                                const val = e.target.value
                                                this.state.club.postal = val;
                                                this.setState({ club: this.state.club, postalErr: false });
                                            }} />
                                        </div>
                                        <div className="register-input">
                                            <img src="" />
                                            <CountryDropdown classes={(this.state.countryErr) ? "select-input error" : "select-input"}
                                                value={this.state.club.country}
                                                onChange={(val) => {
                                                    this.state.club.country = val;
                                                    this.setState({ club: this.state.club, countryErr: false });
                                                }} />
                                        </div>
                                        <div className="register-input">
                                            <img src="" />
                                            <RegionDropdown classes={(this.state.stateErr) ? "select-input error" : "select-input"}
                                                country={this.state.club.country}
                                                value={this.state.club.state}
                                                onChange={(val) => {
                                                    this.state.club.state = val;
                                                    this.setState({ club: this.state.club, stateErr: false });
                                                }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="register-profile-content-body-item">
                                    <h2>Add sports offered by this institution</h2>
                                    <div className={(this.state.sportsErr) ? "added-sports-list error" : "added-sports-list"}>
                                        {
                                            this.state.club.sports.map((item, i) => {

                                                return (
                                                    <div key={i} className="added-sport-item">
                                                        <img src={(item.image === null) ? "" : item.image.replace("_wht", "")} />
                                                    </div>
                                                )
                                            })
                                        }
                                        <div className="add-to-sport" onClick={() => {
                                            this.setState({
                                                isAddingSports: true
                                            });
                                        }}>
                                            <img src="images/add_blu.svg" /> Add
                                        </div>
                                    </div>
                                    <h2>Add sports person</h2>
                                    {(this.state.club.sports.length === 0) &&
                                        <div>
                                            Choose sports before you can add sports person
                                        </div>
                                    }
                                    <div className={(this.state.sportPersonsErr) ? "sports-peron-list error" : "sports-peron-list"}>
                                        {
                                            this.state.club.sportPersons.map((item, i) => {
                                                return (
                                                    <AddedSportItem key={i} item={item} removeUser={(key) => {
                                                        item[key] = { id: null, name: "" }
                                                        this.setState({ club: this.state.club });
                                                    }} />
                                                )
                                            })
                                        }
                                    </div>
                                    {(this.state.club.sports.length > 0) &&
                                        <div className={"added-sports-list"}>
                                            <div className="add-to-sport" onClick={() => {
                                                this.setState({
                                                    isAddingPersons: true
                                                });
                                            }}>
                                                <img src="images/add_blu.svg" /> Add
                                            </div>
                                        </div>
                                    }
                                    <h2>Add teams to this institution</h2>
                                    {(this.state.club.sports.length === 0 && !this.state.canAddTeams) &&
                                        <div>
                                            Choose sports before you can add teams
                                        </div>
                                    }
                                    {(this.state.club.sports.length > 0 && !this.state.canAddTeams) &&
                                        <div>
                                            If you want add teams to your institution, click <a style={{ fontWeight: "bold", cursor: "pointer" }} onClick={() => {
                                                this.setState({ canAddTeams: true });
                                            }}>here</a>, otherwise you can add them later!
                                    </div>
                                    }
                                    {(this.state.club.sports.length > 0 && this.state.canAddTeams) &&
                                        <div className={(this.state.teamsErr) ? "added-teams-list error" : "added-teams-list"}>
                                            {
                                                this.state.club.teams.map((item, i) => {

                                                    return (
                                                        <AddedTeamItem sports={this.getSportByName(item.sport)} delete={() => {
                                                            this.state.club.teams.splice(i, 1)
                                                            this.setState({ club: this.state.club });
                                                        }} save={(arr) => {
                                                            item: arr
                                                            this.setState({ club: this.state.club });
                                                        }} key={i} item={item} deleteKey={(key) => {
                                                            item[key].hide = true
                                                            this.setState({ club: this.state.club });
                                                        }} />
                                                    )
                                                })
                                            }
                                        </div>
                                    }
                                    {(this.state.club.sports.length > 0 && this.state.canAddTeams) &&
                                        <div className={"added-sports-list"}>
                                            <div className="add-to-sport" onClick={() => {
                                                this.setState({
                                                    isAddingTeams: true
                                                });
                                            }}>
                                                <img src="images/add_blu.svg" /> Add
                                        </div>
                                            <div className="flexCenter" onClick={() => {
                                                this.setState({ canAddTeams: false, teamsErr: false });
                                            }}>or <a style={{ fontWeight: "bold", cursor: "pointer", marginLeft: "10px" }} >Add Later</a></div>
                                        </div>
                                    }
                                </div>
                                <div className="register-profile-content-body-item">
                                    <h2>Confirmation</h2>
                                    <div>
                                        <p>To Confirm that <b>{(this.state.club.name === "") ? "this institution " : this.state.club.name}</b> does exist please enter at least one person’s name from one of the sports teams that make up the teams at the institution.</p>
                                        <input className={(this.state.confirmeeNameErr) ? "error" : ""} placeholder="Name" value={this.state.confirmee.name} onChange={(e) => {
                                            const val = e.target.value
                                            this.state.confirmee.name = val;
                                            this.setState({ confirmee: this.state.confirmee, confirmeeNameErr: false });
                                        }} />
                                        <div className="register-input">
                                            <img src="images/email_icon_blu.svg" />
                                            <input className={(this.state.confirmeeEmailErr) ? "error" : ""} placeholder="name@example.com" value={this.state.confirmee.email} onChange={(e) => {
                                                const val = e.target.value
                                                this.state.confirmee.email = val;
                                                this.setState({ confirmee: this.state.confirmee, confirmeeEmailErr: !FakeData.isEmail(val) });
                                            }} />
                                        </div>
                                        <p className={this.state.needRoles ? "error" : ""}>If you have selected your role as <b>Club Manager, Coach, Referee or Score keeper</b> you will need to be verified by an additional person. This is important, non-verification of your role will mean you cannot create games or access the Game Management console (GMC).</p>
                                        <div>
                                            {
                                                this.state.othersVerifications.map((item, i) => {
                                                    return (
                                                        <div key={i} className="verify-input">
                                                            <input placeholder="Name" className={(item.nameError) ? "error" : ""} value={item.name} onChange={(e) => {
                                                                const val = e.target.value
                                                                item.name = val;
                                                                item.nameError = false
                                                                this.setState({ othersVerifications: this.state.othersVerifications });
                                                            }} />
                                                            <div className="register-input">
                                                                <img src="images/email_icon_blu.svg" />
                                                                <input className={(item.emailErr) ? "error" : ""} placeholder="name@example.com" value={item.email} onChange={(e) => {
                                                                    const val = e.target.value
                                                                    item.email = val;
                                                                    item.emailErr = !FakeData.isEmail(val)
                                                                    this.setState({ othersVerifications: this.state.othersVerifications });
                                                                }} />
                                                                <i className="material-icons" onClick={() => {
                                                                    this.state.othersVerifications.splice(i, 1)
                                                                    this.setState({ othersVerifications: this.state.othersVerifications });
                                                                }}>delete</i>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                        <div className="profile_add_item_alt" onClick={() => {
                                            if ((this.state.yourRole.role === "Admin" || this.state.yourRole.role === "Staff" || this.state.yourRole.role === "")) {
                                                return;
                                            } else if ((this.state.othersVerifications[this.state.othersVerifications.length - 1] && (this.state.othersVerifications[this.state.othersVerifications.length - 1].name === "" || this.state.othersVerifications[this.state.othersVerifications.length - 1].email === ""))) {
                                                return
                                            }
                                            this.state.othersVerifications.push({ name: "", nameError: false, email: "", emailErr: false })
                                            this.setState({ othersVerifications: this.state.othersVerifications, needRoles: false });
                                        }}>Add a verification contact</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div tabIndex="0" className="after-register-profile-button gbl-btn" onClick={this.save.bind(this)}>Save Profile</div>
                    </div>
                }
                {this.state.isAfterReg &&
                    <div className="after-register-profile" style={{ width: "85%" }}>
                        <div className="after-reg">
                            <h3>Institution page created successfully!</h3>
                            <Link  to={{ pathname: "/institution/" + this.state.club.username, search: '?sInit=about' }}>Continue to Institution Page</Link>
                        </div>
                    </div>
                }
                <AddSportFollow isOpen={this.state.isAddingSports} onClose={this.onSportsFollowAdd.bind(this)} />
                <AddTeamWithSquads isClub={false} sports={sports} isOpen={this.state.isAddingTeams} onClose={(arr) => {
                    if (arr === null) {
                        this.setState({
                            isAddingTeams: false
                        });
                    } else {
                        this.state.club.teams.push(arr)
                        this.setState({
                            isAddingTeams: false,
                            club: this.state.club
                        });
                    }

                }} />
                {this.state.club.sportPersons.length > 0 &&
                    <AddSportsPerson sports={this.state.club.sportPersons} isOpen={this.state.isAddingPersons} onClose={this.savePersons.bind(this)} />
                }
            </div >
        );
    }

}

class AddSportsPerson extends Component {
    constructor(p) {
        super(p)
        this.state = {
            sports: FakeData.listify(this.props.sports)
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ sports: FakeData.listify(nextProps.sports) });
    }

    onSave() {
        const sports = this.state.sports;
        let bool = false;
        /*this.state.sports.forEach((item, i) => {
            if (item.headDept.id === null) {
                item.headDeptErr = true;
                bool = true;
            }

            if (item.assDept.id === null) {
                item.assDeptErr = true;
                bool = true;
            }

            if (item.headCoach.id === null) {
                item.headCoachErr = true;
                bool = true;
            }

            if (item.assCoach.id === null) {
                item.assCoachErr = true;
                bool = true;
            }

            this.setState({ sports: this.state.sports });
        })
        if (bool) {
            return;
        }*/

        this.props.onClose(sports)
    }

    render() {
        return (
            <Modal isOpen={this.props.isOpen} onClose={this.onSave.bind(this)}>
                <div className="add-place" style={{ width: "600px" }}>
                    <h1>Add Persons</h1>
                    <div>All the fields are optional at this stage, you can fill them in now or close this popup!</div><br />
                    {
                        this.state.sports.map((item, i) => {
                            return (
                                <div key={i} className="add-sports-person">
                                    <img src={item.image.replace("_wht", "")} />
                                    <div key={item.name + i} className="add-sports-person-fields">
                                        <ItemPicker key={"hd" + i} value={item.headDept.name} label="Head of department" user={FakeData.getData("yoo")} error={item.headDeptErr} onSelectedItem={(user) => {
                                            item.headDept = user;
                                            item.headDeptErr = false
                                            this.setState({ sports: this.state.sports });
                                        }} width="27.85em" isExtended={true} data={(FakeData.getData("yoo")) ? FakeData.getData("yoo").friends : []} />
                                        <ItemPicker key={"ah" + i} value={item.assDept.name} label="Assistant head of department" user={FakeData.getData("yoo")} error={item.assDeptErr} onSelectedItem={(user) => {
                                            item.assDept = user;
                                            item.assDeptErr = false
                                            this.setState({ sports: this.state.sports });
                                        }} width="27.85em" isExtended={true} data={(FakeData.getData("yoo")) ? FakeData.getData("yoo").friends : []} />
                                        <ItemPicker key={"hc" + i} value={item.headCoach.name} label="Head Coach" user={FakeData.getData("yoo")} error={item.headCoachErr} onSelectedItem={(user) => {
                                            item.headCoach = user;
                                            item.headCoachErr = false
                                            this.setState({ sports: this.state.sports });
                                        }} width="27.85em" isExtended={true} data={(FakeData.getData("yoo")) ? FakeData.getData("yoo").friends : []} />
                                        <ItemPicker key={"ac" + i} value={item.assCoach.name} label="Assistant Coach" user={FakeData.getData("yoo")} error={item.assCoachErr} onSelectedItem={(user) => {
                                            item.assCoach = user;
                                            item.assCoachErr = false
                                            this.setState({ sports: this.state.sports });
                                        }} width="27.85em" isExtended={true} data={(FakeData.getData("yoo")) ? FakeData.getData("yoo").friends : []} />
                                    </div>
                                </div>
                            )
                        })
                    }
                    <button onClick={this.onSave.bind(this)}>Save</button>
                </div>
            </Modal>
        );
    }
}

class AddedSportItem extends Component {
    constructor(p) {
        super(p)
    }

    render() {
        const { item } = this.props
        return (
            <div className="sports-peron-list-item">
                <h4>{item.name}</h4>
                <div>
                    {item.headDept.id !== null &&
                        <div data-desc={item.headDept.name}>
                            <img src={item.headDept.image} />
                            <span onClick={() => this.props.removeUser("headDept")}>x</span>
                        </div>
                    }
                    {item.assDept.id !== null &&
                        <div data-desc={item.assDept.name}>
                            <img src={item.assDept.image} />
                            <span onClick={() => this.props.removeUser("assDept")}>x</span>
                        </div>
                    }
                    {item.headCoach.id !== null &&
                        <div data-desc={item.headCoach.name}>
                            <img src={item.headCoach.image} />
                            <span onClick={() => this.props.removeUser("headCoach")}>x</span>
                        </div>
                    }
                    {item.assCoach.id !== null &&
                        <div data-desc={item.assCoach.name}>
                            <img src={item.assCoach.image} />
                            <span onClick={() => this.props.removeUser("assCoach")}>x</span>
                        </div>
                    }
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/CreatePages/EducationInit.jsx